import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { defaultProfile } from "../../constants";
import EditUserProfileForm from "../../components/profile/editForm";
import UserPageWidget from "../../components/profile/pageWidget";
import DocumentUploadForm from "../../components/profile/documentLoadForm";
import PanelSubHeading from "../../components/panel/subHeading";
import { actions, RootState } from "../../state/reducer";
import { userBackend } from "../../services";
import PanelPage from "../../components/panel/panelPage";
import { closeModal, openModal } from "../../state/modalSlice";
import NewPasswordModal from "../../modals/users/setPassword";

const EditProfilePage = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const session = State.session;

  useEffect(() => {
    if (!session) return;
    userBackend
      .getUserFiles(session.id)
      .then((res) => {
        console.log(res);
        dispatch(actions.currentUserPhotos(res.files));
      })
      .catch((e) => {
        console.log(e);
      });
  }, [session]);

  const handleOpenPasswordModal = () => {
    if (!session) return;
    dispatch(
      openModal({
        component: NewPasswordModal,
        context: {
          user_id: session.id,
          onSave: (file: File) => {},
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  return (
    <PanelPage>
      <div className="flex between">
        <PanelSubHeading
          text={`Редактировать: ${State.currentPersonal?.last_name || ""} ${
            State.currentPersonal?.first_name || ""
          }`}
        />
        <div className="panelBtnContainer">
          <a href="/profile">
            <div className="btn panelActionBtn">Просмотр</div>
          </a>
        </div>
      </div>
      <div className="flex between panelColumnFull">
        <div className="panelColumnMain">
          <div className="profileWidget">
            <div className="panel panelInner">
              <EditUserProfileForm />
            </div>
          </div>
          <PanelSubHeading
            text={`Документы: ${defaultProfile.last_name} ${defaultProfile.first_name}`}
          />
          <div className="profileWidget">
            <div className="panel panelInner">
              <DocumentUploadForm />
            </div>
          </div>
        </div>
        <div className="panelColumnSub columnRight gap24">
          <UserPageWidget
            editable={true}
            profile={State.currentPersonal || defaultProfile}
            files={State.currentUserPhoto}
          />
          <div style={{marginRight: 24 }}>
            <div
              className="btn panelActionBtn"
              onClick={handleOpenPasswordModal}
            >
              Сменить пароль
            </div>
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default EditProfilePage;
